export const emailToken = (
  state = {
    emailToken: '',
    isValid: false,
    isLoading: false,
  },
  action
) => {
  switch (action.type) {
    case 'UPDATE_EMAIL_TOKEN_STATE': {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};
